export default {"src":"/_next/static/media/aiGlasses.e3fb96e5.svg","height":225,"width":195,"blurWidth":0,"blurHeight":0};